<template>
<div class="div_sec">

  <el-row :gutter="60">
    <el-col :span="24" class="card-01">
      <el-row>
        <el-col :span="21" class="modal_title middle_blue">Operace
        </el-col>
        <el-col :span="21"> <span class="modal_title green small">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
        </el-col>
        <el-col :span="3" style="margin-bottom: 50px;">
          <!-- <el-button class="btn-green" icon="el-icon-plus" size="small" @click="operation_new"> Nová operace</el-button> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-table
            ref="opers_table"
            :data="operations"
            style="width: 100%; word-break: normal;"
            row-key="id_operation"
            v-loading="loading_operations"
            element-loading-text="Loading..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(211, 227, 218, 0.8)"
            :default-sort="{prop:'id_operation', order:'ascending'}"
            border
            highlight-current-row
            @sort-change="SortChange_operations"
            :stripe="true"
          >
            <el-table-column
              prop="id_operation"
              label="ID operace"
              min-width="120"
              sortable>
            </el-table-column>
            <el-table-column
              prop="op_dat_oper"
              label="Datum operace"
              min-width="160"
              sortable>
            </el-table-column>
            <el-table-column
              prop=""
              label="Biopsie"
              min-width="190"
              >
              <template slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Otevřená" placement="top">
                  <span v-if="props.row.op_biop_ot"> <el-tag type="primary" size="mini">OT</el-tag> </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Stereotaxe" placement="top">
                  <span v-if="props.row.op_biop_ster"> <el-tag type="primary" size="mini">ST</el-tag> </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Freehand" placement="top">
                  <span v-if="props.row.op_biop_free"> <el-tag type="primary" size="mini">FR</el-tag> </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Endoskop" placement="top">
                  <span v-if="props.row.op_biop_endo"> <el-tag type="primary" size="mini">EN</el-tag> </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="op_res"
              label="Resekce"
              min-width="170"
              sortable="custom">
              <template slot-scope="props">
                <div v-for="one, index in props.row.op_res"> <span v-if="index > 0"> / </span>{{ one }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="Hydrocefalus"
              min-width="220"
              >
              <template slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Shunt" placement="top">
                  <span v-if="props.row.op_hyd_shu"> <el-tag type="primary" size="mini">SH</el-tag> </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="E3v" placement="top">
                  <span v-if="props.row.op_hyd_ev"> <el-tag type="primary" size="mini">EV</el-tag> </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Kombinace" placement="top">
                  <span v-if="props.row.op_hyd_kom"> <el-tag type="primary" size="mini">KO</el-tag> </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Revize shuntu" placement="top">
                  <span v-if="props.row.op_hyd_rev"> <el-tag type="primary" size="mini">RE</el-tag> </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" placement="top">
                  <template slot="content">
                    <span> Jiný: {{ props.row.op_hyd_jiny_text }} </span>
                  </template>
                  <span v-if="props.row.op_hyd_jiny"> <el-tag type="primary" size="mini">JI</el-tag> </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="op_res_kompl"
              label="Řešení komplikací"
              min-width="220"
              sortable="custom">
              <template slot-scope="props">
                <div v-for="one, index in props.row.op_res_kompl">
                  <span v-for="xone, index in one"> <span v-if="index > 0"> / </span> {{ xone }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="op_endo"
              label="Endoskop"
              min-width="200"
              sortable="custom">
            </el-table-column>
            <el-table-column
              width="380"
              fixed="right"
              label="Akce"
              align="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button :disabled="modal_operation_ro" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="examination_new( props.$index, props.row, $event )">Diag./ud.</el-button>
                  <el-button :disabled="modal_operation_ro" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="checkup_new( props.$index, props.row, $event )">Kontrola</el-button>
                  <el-button :disabled="modal_operation_ro" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="medication_new( props.$index, props.row, $event )">Léčba</el-button>
                  <el-button class="btn-grey-lit" size="mini" icon="el-icon-view" @click="operation_show( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="modal_operation_ro" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="operation_edit( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="modal_operation_ro" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="operation_delete( props.$index, props.row, $event )"></el-button>
                </el-button-group>
              </template>

              <!-- <template slot-scope="props">
                <el-tooltip content="Nové vyšetření" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #f0e4a4; margin: 5px" icon="el-icon-folder-add" @click="examination_new( props.$index, props.row, $event )" circle></el-button>
                </el-tooltip>
                <el-tooltip content="Nová kontrola" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #cfafdb; margin: 5px" icon="el-icon-view" @click="checkup_new( props.$index, props.row, $event )" circle></el-button>
                </el-tooltip>
                <el-tooltip content="Nová léčba" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #c8dbaf; margin: 5px" icon="el-icon-folder-add" @click="medication_new( props.$index, props.row, $event )" circle></el-button>
                </el-tooltip>
                <el-tooltip content="Editace" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #becfe1; margin: 5px" icon="el-icon-edit" @click="operation_edit( props.$index, props.row, $event )" circle></el-button>
                </el-tooltip>
                <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                  <el-button size="small" style="background-color: #e1afaf; color: #581c1c; margin: 5px" icon="el-icon-delete" @click="operation_delete( props.$index, props.row, $event )" circle>
                  </el-button>
                </el-tooltip>
              </template> -->

            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</div>

</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  let notifier = new Vue();

  export default {
    computed: {
      ...mapState({
        loginuser: state => state.loginuser,

        operations: state => state.operations,
        operation: state => state.operation,
        sorting_operations: state => state.sorting_operations,
        loading_operations: state => state.loading_operations,

        patient: state => state.patient,
        examination: state => state.examination,
        checkup: state => state.checkup,
        medication: state => state.medication,

        modal_operation_ro: state => state.modal_operation_ro,


      }),

      ...mapGetters({

      }),


    },


    data () {
      return {

      }
    },

    methods: {
      ...mapMutations({
        m_modal_operation: 'm_modal_operation',
        m_modal_operation_ro: 'm_modal_operation_ro',
        m_operation_by_key: 'm_operation_by_key',
        m_operation_reset: 'm_operation_reset',

        m_examination_reset: 'm_examination_reset',
        m_modal_examination: 'm_modal_examination',
        m_modal_examination_ro: 'm_modal_examination_ro',

        m_checkup_reset: 'm_checkup_reset',
        m_modal_checkup: 'm_modal_checkup',
        m_modal_checkup_ro: 'm_modal_checkup_ro',

        m_medication_reset: 'm_medication_reset',
        m_modal_medication: 'm_modal_medication',
        m_modal_medication_ro: 'm_modal_medication_ro',

      }),


      ...mapActions({
        a_operation: 'a_operation',
        a_operations: 'a_operations',
        a_operation_delete: 'a_operation_delete',

        a_med_cis_bio_ter_lek: 'a_med_cis_bio_ter_lek',
        a_med_cis_protokol: 'a_med_cis_protokol',
        a_med_cis_chem_int_cyt: 'a_med_cis_chem_int_cyt',
        a_med_cis_chem_int_inthe_inver_cyt: 'a_med_cis_chem_int_inthe_inver_cyt',
        a_med_cis_udr_chem_inthe_inver_cyt: 'a_med_cis_udr_chem_inthe_inver_cyt',

        }),


      operation_new() {
        this.m_operation_reset();
        this.operation.id_patient = this.patient.id_patient;
        this.m_modal_operation(true);
      },


      operation_show (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_operation_ro(true);
        this.m_operation_reset();
        this.operation.id_operation = row.id_operation;
        this.a_operation( {'id_operation': row.id_operation} );
        this.m_modal_operation(true);
      },


      operation_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_operation_ro(false);
        this.m_operation_reset();
        this.operation.id_operation = row.id_operation;
        this.a_operation( {'id_operation': row.id_operation} );
        this.m_modal_operation(true);
      },


      operation_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.$confirm(`Opravdu chcete položku smazat?`, 'Upozornění', {
          confirmButtonText: 'ANO',
          cancelButtonText: 'NE',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.a_operation_delete( {'id_operation': row.id_operation} );
          this.a_operations( {} );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Smazání položky přerušeno.'
          });
        });
      },


      examination_new(index, row, event) {
        this.m_modal_examination_ro(false);
        this.m_examination_reset();
        this.examination.id_patient = this.patient.id_patient;
        this.examination.id_operation = row.id_operation;
        this.m_modal_examination(true);
      },


      checkup_new(index, row, event) {
        this.m_modal_checkup_ro(false);
        this.m_checkup_reset();
        this.checkup.id_patient = this.patient.id_patient;
        this.checkup.id_operation = row.id_operation;
        this.m_modal_checkup(true);
      },


      medication_new(index, row, event) {
        this.m_modal_medication_ro(false);
        this.m_medication_reset();
        this.a_med_cis_bio_ter_lek();
        this.a_med_cis_protokol();
        this.a_med_cis_chem_int_cyt();
        this.a_med_cis_chem_int_inthe_inver_cyt();
        this.a_med_cis_udr_chem_inthe_inver_cyt();
        this.medication.id_patient = this.patient.id_patient;
        this.medication.id_operation = row.id_operation;
        this.m_modal_medication(true);
      },


      SortChange_operations(val) {
        this.sorting_operations.sorting_prop = val.prop;
        this.sorting_operations.sorting_ordering = val.order;
        this.a_operations();
      },


      handleChange(value) {
        console.log(value);
      },


      vymaz_data(value) {
        this.operation[value] = null;
        console.log(value);
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },


    },

    beforeMount () {
    },

    created () {
    },

    mounted () {

    },

    beforeDestroy () {
    },


  }
</script>

<style lang="scss">

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}

.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}

.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

.el-select .el-input {
  width: 220px !important;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item {
   margin-bottom: 0 !important;
  }

.el-select {
  padding: 0 20px 10px 0 !important;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #7b8d9f;
    cursor: not-allowed;
}


</style>

